import type { ApexOptions } from 'apexcharts';
import { deepMerge } from '@witmetrics/utils/objects';
import { shadows, theme } from '@/utils/theme';
import { DEFAULT_CHART_OPTIONS } from './constants';

export const classes = {
  wrapper: 'h-full',
};

export const styles = {
  wrapper: {
    '& .apexcharts-tooltip': {
      backgroundColor: 'hsla(0, 0%, 100%, 0.6) !important',
      border: `1px solid ${theme.palette['grey-3'].main} !important`,
      boxShadow: shadows.dialog,
      borderRadius: '8px',
      backdropFilter: 'blur(8px)',
      padding: '0.5rem 1.25rem 0.5rem 0.75rem !important',
    },
    '& .apexcharts-tooltip-title': {
      background: 'none !important',
      border: 'none !important',
      fontFamily: 'Inter !important',
      fontSize: '0.8rem !important',
      fontWeight: '600 !important',
      padding: '0 !important',
    },
    '& .apexcharts-tooltip-series-group': {
      padding: '0 !important',
    },
    '& .apexcharts-tooltip-text-y-label': {
      fontFamily: 'Inter !important',
      fontSize: '0.9rem !important',
      fontWeight: '600 !important',
    },
    '& .apexcharts-tooltip-text-y-value': {
      fontFamily: 'Inter !important',
      fontSize: '0.9rem !important',
      fontWeight: '400 !important',
      marginLeft: '0.1rem',
    },
  },
};

export function buildBarGradientFill(
  gradients: { top: string }[],
  solidColors: string[] = []
): ApexOptions['fill'] {
  return {
    type: [
      ...gradients.map(() => 'gradient'),
      ...solidColors.map(() => 'solid'),
    ],
    gradient: {
      type: 'vertical',
      shadeIntensity: 0,
      gradientToColors: [...gradients.map((g) => g.top), ...solidColors],
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 100],
    },
  };
}

export function mergeChartOptions(options: ApexOptions): ApexOptions {
  const merged = deepMerge(DEFAULT_CHART_OPTIONS, options);
  // deepMerge flattens a multi-axis yaxis array into the defaults' object — merge per-axis instead
  if (Array.isArray(options.yaxis)) {
    merged.yaxis = options.yaxis.map((axis) =>
      deepMerge(DEFAULT_CHART_OPTIONS.yaxis as object, axis)
    );
  }
  return merged;
}
